import { InjectionToken } from '@angular/core';

export const ICONS_PATH = new InjectionToken<string>(
  'Pass to the icons folder',
);
